<template>
    <div id="About">
        <h2 class="componentheader">About</h2>
        <p>I find playing PC games very fun. I've always played PC games growing up and never really got into gaming consoles like PlayStation or Xbox mostly because I never had them growing up so using the remotes is as tough as rocket science to me. I play games casually so don't look to me in my gaming abilities!</p>
        <p>Recently, I have picked up playing League of Legends. Other games I've enjoyed included Call of Duty, Left 4 Dead / Left 4 Dead 2, and also Portals! Other games I've played included Caesar, Age of Empires and also Warcraft III. </p>
        <p>My social media accounts are focused on showing League of Legends gameplays. It has been pretty frustrating playing ranked games recently. Despite the frustrations, keep playing, and keep Laughing out Loud! See what I did there?? The clever play on word... I know I am geeky.</p>
        <p>As always, xoxo S2!</p>
        <div v-lazy-container="{selector:'img'}">
          <img data-src="static/images/YouTube_ChannelArt.png" alt="Keep LoLing S2 Channel Art"/>
        </div>
    </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue